import type { FunctionComponent } from 'react';

import { useWidget } from '@rango-dev/widget-embedded';
import React, { useContext, useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { BrowserRouter as Router } from 'react-router-dom';

import { BaseRoutes } from './BaseRoutes';
import { CustomSocialWalletProviderContext } from './components/CustomSocialWalletProvider';
import { Layout } from './components/Layout';
import { useAppDispatch } from './hooks/reduxHooks';
import Error from './pages/Error';
import { setMeta } from './state/MetaSlice';

/**
 * All routes go here.
 * Don't forget to import the components above after adding new route.
 */
export const AppRouter: FunctionComponent = () => {
  const { meta } = useWidget();
  const dispatch = useAppDispatch();
  const { setSupportedChains: setSocialWalletSupportedChains } = useContext(
    CustomSocialWalletProviderContext,
  );

  useEffect(() => {
    dispatch(
      setMeta({
        blockchains: meta.blockchains,
        tokens: meta.tokens,
        swappers: meta.swappers,
        loadingStatus: meta.loadingStatus,
      }),
    );
    setSocialWalletSupportedChains(meta.blockchains);
  }, [meta.loadingStatus]);

  return (
    <Router>
      <Layout>
        <ErrorBoundary FallbackComponent={Error}>
          <BaseRoutes />
        </ErrorBoundary>
      </Layout>
    </Router>
  );
};
